<template>
  <div class="input-wrapper" :class="{ active: (isFocus || value) && label }">
    <label :for="id" class="input-label">{{ label }}</label>
    <CurrencyInput
      :id="id"
      class="currencyInput"
      @focus="isFocus = true"
      :options="currencyInputOptions"
      @blur="handleBlur"
      @input="value"
      v-bind="{ ...$attrs }"
    />
    <slot name="right-icon"></slot>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import CurrencyInput from "./CurrencyInput.vue";

export default {
  name: "CurrencyInputLabel",
  components: {
    CurrencyInput,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup(props) {
    const isFocus = ref(false);
    const value = ref();

    const handleBlur = (event) => {
      if (!event.target.value) {
        isFocus.value = false;
      } else {
        isFocus.value = true;
      }
    };

    const currencyInputOptions = computed(() => props.options);

    return {
      isFocus,
      value,
      handleBlur,
      currencyInputOptions
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.input-wrapper {
  width: 100%;
  position: relative;

  .input-label {
    position: absolute;
    z-index: 1;
    color: $colorD40;
    left: 12px;
    transition: 0.3s;
    font-size: 12px;
    top: 14px;
  }

  &.active {
    .input-label {
      font-size: 9px;
      top: 7px;
    }

    .currencyInput {
      padding: 17px 12px 4.5px;
    }
  }
}
</style>
